import type { getPublicFormChangeboardingData_jira_jiraProject as getPublicFormChangeboardingDataJiraProject } from '../services/get-data/__generated_apollo__/getPublicFormChangeboardingData.ts';
import { MESSAGE_EVENT_ID, type MessageEventDetails } from './constants.tsx';

const SOFTWARE_TMP_PREFIX = '/jira/software';
const SOFTWARE_CMP_PREFIX = '/jira/software/c';
const BUSINESS_PREFIX = '/jira/core';

type GetFormBuilderUrlProjectParam = Pick<
	getPublicFormChangeboardingDataJiraProject,
	'key' | 'projectType' | 'tmpBoardId'
>;

export const getPrefix = (project: GetFormBuilderUrlProjectParam) => {
	if (project.projectType === 'SOFTWARE') {
		if (project.tmpBoardId !== null) {
			return SOFTWARE_TMP_PREFIX;
		}
		return SOFTWARE_CMP_PREFIX;
	}
	return BUSINESS_PREFIX;
};

type GetFormBuilderUrlParams = {
	project: GetFormBuilderUrlProjectParam;
	formId: string;
};

export const getFormBuilderUrl = ({ project, formId }: GetFormBuilderUrlParams) => {
	return `${getPrefix(project)}/projects/${project.key}/form/${formId}/builder`;
};

export const emitMessageEvent = (eventDetails: MessageEventDetails) => {
	const event = new CustomEvent(MESSAGE_EVENT_ID, {
		detail: eventDetails,
	});

	if (typeof document !== 'undefined') {
		document.dispatchEvent(event);
	}
};
